import { Navigate, Outlet } from 'react-router-dom';
import { useFeatureToggles } from 'hooks/useFeatureToggles';
import { Feature } from '@urbanx/agx.agencies.client';

const RequireAgentProfileSettingsLayout = () => {
  const { isEnabled, isLoading } = useFeatureToggles();

  if (isLoading) return null;

  if (!isEnabled(Feature.AgentProfileSettings)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireAgentProfileSettingsLayout;
